import ownKeys from './ownKeys';

export default function hasGeneratorInterface(handler) {
  var keys = ownKeys(handler);
  var hasOnlyInterfaceNames = keys.every(function (ownKey) {
    return ownKey === 'next' || ownKey === 'throw';
  });
  return keys.length && keys.length <= 2 && hasOnlyInterfaceNames;
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/hasGeneratorInterface.js
// module id = 916
// module chunks = 0